import { DOCUMENT } from '@angular/common'
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { Observable } from 'rxjs'

export const X_ORIGIN_HEADER: string = 'X-Origin'
export const X_REFERER_HEADER: string = 'X-Referer'

/**
 * Adds consistent headers for browsers that don't respect CORS standards
 *
 * @param req   Current HTTP Request that is being made
 * @param next  HTTP Handler that will take over when the request is complete
 *
 * @returns     Returns an observable of the event stream
 */
export function xHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  let window = inject(DOCUMENT).defaultView

  let origin = window.location.origin
  let referer = `${ origin }${ window.location.pathname }`

  let updatedheaders = req.headers
    .set(X_ORIGIN_HEADER, origin)
    .set(X_REFERER_HEADER, referer)

  let updatedRequest = req.clone({
    headers: updatedheaders
  })

  return next(updatedRequest)
}
